import {createContext, useState} from "react";

export const SecQuestionContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    let emptyQuestion = {
        id: "",
        content: "",
        enabled: true
    }

    const [question, setQuestion] = useState(emptyQuestion);
    const [questions, setQuestions] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [questionDialog, setQuestionDialog] = useState(false);

    const resetQuestion = () => {
        setQuestion(emptyQuestion);
    };

    // Make the context object:
    const questionContext = {
        question,
        resetQuestion,
        setQuestion,
        questions,
        setQuestions,
        submitted,
        setSubmitted,
        questionDialog,
        setQuestionDialog,
    };

    // pass the value in provider and return
    return <SecQuestionContext.Provider value={questionContext}>{children}</SecQuestionContext.Provider>;
}

export const {Consumer} = SecQuestionContext;
